import { appFeature } from 'modules/organizer/domain/interfaces/available-feature';
import { useFetchAvailableFeature } from 'shared/hooks/fetchering/use-fetch-available-feature';
import { useIsAdmin } from 'shared/hooks/use-is-admin';

export function useFeature(feature: appFeature) {
  const isAdmin = useIsAdmin();
  const { data, isFetching } = useFetchAvailableFeature();

  if (isAdmin) return { isEnabled: true, isFetching: false };
  return { isEnabled: data?.[feature] ?? false, isFetching };
}
